import { HttpMethod } from 'models/HttpMethod';

export function buildRequestSettings(
  method: HttpMethod,
  accessToken: string | undefined,
  bodyData: any,
): RequestInit {
  const settings: RequestInit = {
    method,
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };
  if (bodyData) {
    settings.body = JSON.stringify(bodyData);
  }
  return settings;
}
